import React from 'react'
import styled from 'particles/themes/styled'
import Menu from '.'
import { MenuProps, menuClasses } from '@mui/material/Menu'
import { useWindowSize } from 'hooks/index'

interface RichContentMenuProps extends MenuProps {
    isVertical?: boolean
}

interface StyledMenuProps extends RichContentMenuProps {
    isMobileSize?: boolean
}

const StyledMenu = styled(Menu)<StyledMenuProps>`
    gap: ${({ theme }) => theme.spacing[300]};
    & .${menuClasses.paper} {
        max-height: ${({ isVertical, isMobileSize }) => (isVertical || isMobileSize ? '360px' : 'fit-content')};

        & .${menuClasses.list} {
            flex-direction: ${({ isVertical, isMobileSize }) => (isVertical || isMobileSize ? 'column' : 'row')};
            gap: ${({ isVertical, theme }) => (isVertical ? theme.spacing[200] : theme.spacing[300])};
        }

        .menu-section {
            width: ${({ isVertical, isMobileSize }) => (isVertical || isMobileSize ? '248px' : '300px')};
            display: flex;
            flex-direction: column;
            gap: ${({ theme }) => theme.spacing[100]};
        }
    }
`

const RichContentMenu: React.FC<RichContentMenuProps> = ({ isVertical = true, children, ...props }) => {
    const windowSize = useWindowSize()
    const isMobileSize = windowSize <= 768

    return (
        <StyledMenu {...props} isVertical={isVertical} isMobileSize={isMobileSize}>
            {children}
        </StyledMenu>
    )
}

export default RichContentMenu
